<template>
  <div class="ly_mainInner">
    <div class="bl_mainvisBlock">
      <div class="bl_bgImg">
        <img class="pcBlock" src="/kids/quiz/static/image/mainvis_bg.png" alt="">
        <img class="spBlock" src="/kids/quiz/static/image/sp/mainvis_bg.png" alt="">
      </div>
      <!-- eslint-disable-next-line -->
      <p class="bl_mainvisBlock_txt">クイズに<ruby>答<rp>(</rp><rt>こた</rt><rp>)</rp></ruby>えて<br class="spBlock">おだきゅうマスターになろう！</p>
      <div class="bl_mainvisBlock_img">
        <img src="/kids/quiz/static/image/mainvis_txt.png" alt="おだきゅう検定">
      </div>
      <div class="bl_btnBlock">
        <ul class="bl_btnBlockInner">
          <li>
            <a class="el_btn" href="#" @click="openDataClear()">はじめから</a>
          </li>
          <li v-if="isData()">
            <a class="el_btn" href="#" @click="changeCurrentPage()">つづきから</a>
          </li>
        </ul>
        <ul class="bl_btnBlockInner bl_btnBlock__flexColumn">
          <li>
            <!-- eslint-disable-next-line -->
            <a class="el_btn el_btn__white un_btn_txt" href="#" @click="openTutorial()"><ruby>遊<rp>(</rp><rt>あそ</rt><rp>)</rp></ruby>び<ruby>方<rp>(</rp><rt>かた</rt><rp>)</rp></ruby></a>
          </li>
          <li>
            <a class="el_btn el_btn__gray" href="/kids/">トップへ</a>
          </li>
        </ul>
      </div>
    </div>
    <DataClear v-if="dataClear" @close="closeDataClear()"/>
    <Tutorial v-if="tutorial" @close="closeTutorial()"/>
  </div>
</template>

<script>
import Tutorial from '@/components/Tutorial';
import DataClear from '@/components/DataClear';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Start',
  components: {
    Tutorial,
    DataClear,
  },
  data() {
    return {
      tutorial: false,
      dataClear: false,
      startBtnFlg: false,
    };
  },
  computed: {
    ...mapMutations('odakyuQuizClearData', [
      'setClearData',
    ]),
    ...mapState('odakyuQuizClearData', [
      'clearData',
    ]),
    ...mapMutations('odakyuQuizLoadData', [
      'setLoadData',
    ]),
    ...mapState('odakyuQuizLoadData', [
      'loadData',
    ]),
  },
  methods: {
    changeCurrentPage() {
      if (this.loadData.grade > 0 && this.loadData.stage > 0) {
        this.$store.commit('selectLevel/setSelectLevel', this.loadData);
        this.$store.commit('currentPage/changeCurrentPage', 'question');
      } else if (this.clearData.grade > 0 && this.clearData.stage > 0) {
        this.$store.commit('currentPage/changeCurrentPage', 'selectGrade');
      }
      return false;
    },
    isData() {
      if (this.loadData.grade > 0 || this.clearData.grade > 0) {
        return true;
      }
      return false;
    },
    openTutorial() {
      this.tutorial = true;
    },
    closeTutorial() {
      this.tutorial = false;
      if (!this.isLocalData() && this.startBtnFlg) {
        this.dataClear = true;
        this.startBtnFlg = false;
      }
    },
    openDataClear() {
      if (!this.isLocalData()) {
        this.startBtnFlg = true;
        this.tutorial = true;
      } else {
        this.dataClear = true;
      }
    },
    closeDataClear() {
      this.dataClear = false;
    },
    isLocalData() {
      return localStorage.getItem('odakyuQuizData');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.ly_header{
  display: none;
}

.ly_mainInner{
  max-width: 1024px;
  padding-top: 35px;

  .bl_mainvisBlock{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;

    .bl_bgImg{
      width: 110%;
      position: absolute;
      top: 0;
      left: -4%;
      z-index: -1;
    }

    .bl_mainvisBlock_txt{
      color: #000;
      font-size: 2.053vw;
      font-weight: bold;
      line-height: 46px;
      letter-spacing: 0;
      text-align: center;
      margin-bottom: 33px;
    }

    .bl_mainvisBlock_img{
      max-width: 495px;
      width: 50%;
      min-height: 0%;
      display: flex;
      align-items: center;
    }

    .bl_btnBlock{
      width: 100%;
      padding: 0 15px 15px 15px;
      margin-top: 20px;

      .bl_btnBlockInner{
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

        &:last-of-type{
          margin-bottom: 0;
        }

        > li{
          width: 100%;
          max-width: 324.7px;
          text-align: center;
          margin-left: 9.3px;

          &:first-of-type{
            margin-left: 0;
          }
        }

        &.bl_btnBlock__flexColumn{
          flex-direction: column;
          align-items: center;

          > li{
            margin-bottom: 8px;
            margin-left: 0;

            &:last-of-type{
              margin-bottom: 0;
            }

            .el_btn__white{
              height: 38px;
              font-size: 13px;
              padding: 5px 12px;

              &:hover{
                padding: 4.5px 11.5px;
              }

              &.un_btn_txt{
                // line-height: 2.6;
                display: inline-block;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px){
  .ly_mainInner{

    .bl_mainvisBlock{
      margin-top: 20px;

      .bl_bgImg{
        width: 100%;
        top: -14vw;
        left: -3%;
      }

      .bl_mainvisBlock_txt{
        font-size: 3.5vw;
        line-height: 4.5vw;
        margin-bottom: 8%;
      }

      .bl_btnBlock{
        width: 100%;
        margin-top: 10%;

        .bl_btnBlockInner{
          flex-direction: column;
          margin-bottom: 0;

          > li{
            width: 100%;
            max-width: none;
            margin-left: 0;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1024px){
  .ly_mainInner{
    .bl_mainvisBlock{
      .bl_mainvisBlock_txt{
        font-size: 21px;
      }
    }
  }
}

@media all and (-ms-high-contrast:none){
  .ly_mainInner{
    .bl_mainvisBlock{
      .bl_mainvisBlock_img{
        display: block;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Start.vue